import React, { useState, useEffect } from "react";
import Header from "../Layout/Header";
import Footer from "../Layout/Footer";
import { Container, Row, Col, Form, Button, Card, CardBody } from "react-bootstrap";
import "./createproposal.css";
import toast, { Toaster } from "react-hot-toast";
import { Link } from "react-router-dom";
import config from "../../config/config";

export default function Createproposal() {

    const [formData, setFormData] = useState({
      token: "",
      tokenAddress: "",
      ownerAddress: "",
      votingDuration: "",
      proposalText: "",
    });
  
    const handleChange = (e) => {
      setFormData({ ...formData, [e.target.name]: e.target.value });
    };
  
    const handleSubmit = (e) => {
      e.preventDefault();
      console.log("Submitted:", formData);
      // Add form submission logic here
    };

  return (
    <>
      <Toaster />
      <Header />
      <div className="bg-darkgrey">
          <section className=" py-5 position-relative">
          <div className="logoIcon">
            <img src="images/shape/mainIcon.svg" className="mainIcon1 position-absolute" />
             <img src="images/shape/mainIcon.svg" className="mainIcon2 position-absolute" />
          </div>
          <Container className="py-4">
            <Row className="justify-content-center">
              <Col lg={8} className="">
                <div
                  className="cardStyle3 text-white">
                  <Card>
                    <CardBody className="p-5">
                      <div className="headingbox position-relative text-transform">
                        <h4 className="mb-4 fw-bold text-white">CREATE PROPOSAL</h4>
                        <Form onSubmit={handleSubmit}>
                          <Row className="mb-3">
                            <Col md={6}>
                              <Form.Group controlId="token">
                                <Form.Label>Select Token</Form.Label>
                                <Form.Select
                                  name="token"
                                  value={formData.token}
                                  onChange={handleChange}
                                >
                                  <option>Select Token</option>
                                  <option value="token1">Token 1</option>
                                  <option value="token2">Token 2</option>
                                </Form.Select>
                              </Form.Group>
                            </Col>

                            <Col md={6}>
                              <Form.Group controlId="tokenAddress">
                                <Form.Label>Token Address</Form.Label>
                                <Form.Control
                                  type="text"
                                  placeholder="Enter Token Address"
                                  name="tokenAddress"
                                  value={formData.tokenAddress}
                                  onChange={handleChange}
                                />
                              </Form.Group>
                            </Col>
                          </Row>

                          <Row className="mb-3">
                            <Col md={6}>
                              <Form.Group controlId="ownerAddress">
                                <Form.Label>Owner Address</Form.Label>
                                <Form.Control
                                  type="text"
                                  placeholder="Enter Owner Address"
                                  name="ownerAddress"
                                  value={formData.ownerAddress}
                                  onChange={handleChange}
                                />
                              </Form.Group>
                            </Col>

                            <Col md={6}>
                              <Form.Group controlId="votingDuration">
                                <Form.Label>Voting Duration</Form.Label>
                                <Form.Select
                                  name="votingDuration"
                                  value={formData.votingDuration}
                                  onChange={handleChange}
                                >
                                  <option>Select (Max 48 hours)</option>
                                  <option value="12">12 Hours</option>
                                  <option value="24">24 Hours</option>
                                  <option value="48">48 Hours</option>
                                </Form.Select>
                              </Form.Group>
                            </Col>
                          </Row>

                          <Form.Group className="mb-3" controlId="proposalText">
                            <Form.Label>Proposal Text</Form.Label>
                            <Form.Control
                              as="textarea"
                              rows={5}
                              placeholder="Type Here Start Trading, Stop Trading.."
                              name="proposalText"
                              value={formData.proposalText}
                              onChange={handleChange}
                              maxLength={2500}
                            />
                            <Form.Text muted>
                              Please keep your description up to 2,500 characters.
                            </Form.Text>
                          </Form.Group>

                          <div className="text-end">
                            <Button variant="info" type="submit" className="text-white px-4">
                              SUBMIT
                            </Button>
                          </div>
                        </Form>
                      </div>
                    </CardBody>
                  </Card>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
      </div>
      <Footer />
    </>
  );
}
